import React, { useState, useEffect } from 'react';

const TextCaptcha = ({ onVerify }) => {
  const [captchaText, setCaptchaText] = useState('');
  const [userInput, setUserInput] = useState('');
  const [isVerified, setIsVerified] = useState(false);

  // Generate random CAPTCHA text
  const generateCaptcha = () => {
    const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = '';
    for (let i = 0; i < 5; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptchaText(result);
    setUserInput('');
    setIsVerified(false);
    onVerify(false);
  };

  // Generate initial CAPTCHA
  useEffect(() => {
    generateCaptcha();
  }, []);

  // Handle input change
  const handleInputChange = (e) => {
    const value = e.target.value.toUpperCase();
    setUserInput(value);
    
    // Auto-verify when input length matches CAPTCHA length
    if (value.length === 5) {
      const verified = value === captchaText;
      setIsVerified(verified);
      onVerify(verified);
    } else {
      setIsVerified(false);
      onVerify(false);
    }
  };

  // Handle refresh button click
  const handleRefresh = (e) => {
    e.preventDefault();
    generateCaptcha();
  };

  return (
    <div className="mt-4">
      <div className="flex items-center mb-2">
        <div className="flex-1 bg-gray-100 p-2 rounded-md text-center font-mono text-lg tracking-wider select-none">
          {captchaText}
        </div>
        <button
          type="button"
          onClick={handleRefresh}
          className="ml-2 p-2 text-gray-600 hover:text-gray-800 focus:outline-none"
          title="Refresh CAPTCHA"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
        </button>
      </div>
      <input
        type="text"
        value={userInput}
        onChange={handleInputChange}
        placeholder="Enter the code above"
        className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-1 ${
          userInput.length === 5
            ? isVerified
              ? 'border-green-500 bg-green-50 focus:ring-green-500 focus:border-green-500'
              : 'border-red-500 bg-red-50 focus:ring-red-500 focus:border-red-500'
            : 'border-gray-300 focus:ring-indigo-500 focus:border-indigo-500'
        }`}
        maxLength={5}
      />
      {userInput.length === 5 && !isVerified && (
        <p className="mt-1 text-sm text-red-600">The code doesn't match. Please try again.</p>
      )}
      {isVerified && (
        <p className="mt-1 text-sm text-green-600">✓ Verified</p>
      )}
    </div>
  );
};

export default TextCaptcha;
